import React from 'react';
import { connect } from 'react-redux';

import CartListContainer from './CartList';
import CheckoutSummaryContainer from './CheckoutSummaryContainer';
import CheckoutCompleteContainer from './CheckoutCompleteContainer';
import ErrorMessagesContainer from './ErrorMessagesContainer';
import CheckoutPayment from './CheckoutPayment';
import CheckoutBillingAddress from './CheckoutBillingAddress';


class Components extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.checkoutIsEmpty) {
            return (
                <div className="checkout">
                    <div className="col-12 text-center">
                        <p>Your cart is empty.</p>
                        <p><a href="/">Back to home.</a></p>
                    </div>
                </div>
            );
        }

        return (
            <div className="checkout row text-sm">
                <div className="col-12 d-md-none">
                    <CheckoutCompleteContainer />
                    <CheckoutSummaryContainer />
                    <ErrorMessagesContainer />
                </div>

                <div className="col-12 col-md-8" style={{ marginBottom: 20 }}>
                    <CheckoutBillingAddress />
                    <CheckoutPayment />
                    <CartListContainer />
                    <CheckoutCompleteContainer additionalClassname="visible-xs" />
                </div>
                <div className="col-md-4 d-none d-md-block" id='right-summary-container'>
                    <div id='right-summary'>
                        <CheckoutSummaryContainer />
                        <CheckoutCompleteContainer />
                        <ErrorMessagesContainer />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    checkoutIsEmpty: state.entities.CartItems.length < 1
});

export default connect(mapStateToProps)(Components);